export const ACCOUNT_PAGE_KEYS = ['profile', 'invoice', 'payment-history'];

export const ACCOUNT_PORTAL_SLUGS = {
  settings: 'account-settings',
  profile: 'account-profile',
  invoice: 'account-invoice',
  'payment-history': 'account-payment-history',
};

const ROUTE_BY_KEY = {
  profile: '/profile',
  invoice: '/invoice',
  'payment-history': '/payment-history',
};

const PAGE_DEFAULTS = {
  profile: {
    sidebarTitle: 'My Profile',
    pageTitle: 'User Profile',
    pageSubtitle: 'Manage your personal information',
    helpDescription: 'View and update your personal details',
    icon: 'FaUser',
  },
  invoice: {
    sidebarTitle: 'Invoice Download',
    pageTitle: 'My Invoices',
    pageSubtitle: 'Download and manage your invoices',
    helpDescription: 'Access invoices for all online payments made through the portal',
    noteText:
      'Note: Invoices are displayed here only for payments made directly through the portal. If you made a payment outside the portal, please request your invoice by contacting contact@bookscomply.com.',
    icon: 'FaReceipt',
  },
  'payment-history': {
    sidebarTitle: 'Payment History',
    pageTitle: 'Payment History',
    pageSubtitle: 'View all your past transactions and payments',
    helpDescription: 'View the complete history of your transactions through website portal',
    icon: 'FaMoneyBillWave',
  },
};

const SETTINGS_DEFAULTS = {
  title: 'Account Settings',
  icon: 'LuSettings',
  intro: 'The Account Settings section is divided into three key parts:',
};

export const mapAccountPageContent = (content, pageKey) => {
  const defaults = PAGE_DEFAULTS[pageKey] || {};
  return {
    title: content?.pageTitle || defaults.pageTitle || '',
    subtitle: content?.pageSubtitle || defaults.pageSubtitle || '',
    icon: content?.icon || defaults.icon || 'FaUser',
    noteText: content?.noteText || defaults.noteText || '',
    sidebarLabel: content?.sidebarTitle || defaults.sidebarTitle || '',
    helpDescription: content?.helpDescription || defaults.helpDescription || '',
  };
};

export const getAccountSettingsMeta = (settingsContent) => ({
  title: settingsContent?.title || SETTINGS_DEFAULTS.title,
  icon: settingsContent?.icon || SETTINGS_DEFAULTS.icon,
  intro: settingsContent?.intro || SETTINGS_DEFAULTS.intro,
});

/** Build sidebar + help nav items from the three account portal pages */
export const buildAccountNavItems = (profileContent, invoiceContent, paymentHistoryContent) =>
  ACCOUNT_PAGE_KEYS.map((key) => {
    const contentMap = {
      profile: profileContent,
      invoice: invoiceContent,
      'payment-history': paymentHistoryContent,
    };
    const meta = mapAccountPageContent(contentMap[key], key);
    return {
      key,
      slug: ACCOUNT_PORTAL_SLUGS[key],
      route: ROUTE_BY_KEY[key],
      title: meta.sidebarLabel,
      icon: meta.icon,
      helpDescription: meta.helpDescription,
    };
  });

export const getAccountPageMeta = (content, pageKey) => mapAccountPageContent(content, pageKey);

export const getPortalSlugForPageKey = (pageKey) => ACCOUNT_PORTAL_SLUGS[pageKey] || '';
